/**
 * Converts a given value to a boolean.
 * Returns true for 'true' (case-insensitive) or '1'.
 * Returns false for null, undefined, or any other value.
 *
 * @param {*} value - The value to convert.
 * @returns {boolean}
 */
const toBoolean = (value) => {
    if (value == null) {return false;}

    const str = String(value).toLowerCase().trim();
    return str === 'true' || str === '1';
};

export default toBoolean;
